import type { AnalyticsEventHandler } from '@atlassian/navigation-drag-and-drop';
import {
	fireTrackAnalytics,
	useAnalyticsEvents,
	fireUIAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { LEVEL_TWO } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { ROADMAP } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-type.tsx';
import { SECTION_ITEM_STARRED } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { MENU_ID_ROADMAPS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';

export const useDragAndDropReorderingAnalytics = (): {
	fireAnalyticsEvent: AnalyticsEventHandler;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const fireAnalyticsEvent: AnalyticsEventHandler = ({
		action,
		itemId,
		operation,
		successfulReorder,
	}) => {
		const analyticsEvent = createAnalyticsEvent({});
		const baseAttributes = {
			level: LEVEL_TWO,
			componentType: 'customItem',
			itemType: ROADMAP,
			section: SECTION_ITEM_STARRED,
			itemId,
		};
		if (action === 'updated') {
			fireTrackAnalytics(analyticsEvent, {
				action,
				actionSubject: 'sidebarNavigationItems',
				actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_ROADMAPS],
				attributes: {
					...baseAttributes,
					itemId,
					action: operation,
				},
			});
		} else {
			fireUIAnalytics(analyticsEvent, {
				action,
				actionSubject: 'navigationItem',
				actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_ROADMAPS],
				attributes: {
					...baseAttributes,
					itemId,
					successfulReorder,
				},
			});
		}
	};
	return { fireAnalyticsEvent };
};
